import { IFeatureConfig, IHttpResponse } from '@partners/api';
import { isDefined, isUndefined } from '@partners/utils';
import { Observable, of, tap } from 'rxjs';

export function updateFeatureConfig<T = IHttpResponse<any>>(callback?: (config: IFeatureConfig) => void) {
  return (response$: Observable<IHttpResponse<T>>): Observable<IHttpResponse<T>> => {
    return response$.pipe(
      tap((response: IHttpResponse<T>) => {
        const { result } = response;
        if (isDefined(result?.config)) {
          const { config } = result;
          callback && callback.call(null, config);
        }
      })
    );
  };
}
